import { IUserStatusResponse } from "./user-status.interface";
import { USER_STATUS } from "./user-status.query";
import { toastMessageActions } from "../../state/request";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { useUserStatusStore } from "../../hooks/redux-hooks/user-status/user-status.store";
import { userActions } from "../../state/user";

export const useUserStatus = () => {
  const dispatch = useDispatch();
  const { setEmailSignIn } = useUserStatusStore();
  const [statusEmail, { data, loading, error }] = useLazyQuery<{ userStatusByEmail: IUserStatusResponse }>(USER_STATUS);

  const getUserStatus = (email: string) => {
    statusEmail({
      variables: {
        data: {
          email,
        },
      },
      fetchPolicy: "cache-and-network",
    });
    setEmailSignIn(email);
  };

  useEffect(() => {
    dispatch(toastMessageActions.setGlobalLoading(loading));
  }, [loading]);

  useEffect(() => {
    if (data?.userStatusByEmail) {
      dispatch(userActions.setUserStatus(data.userStatusByEmail));
    }
  }, [data]);

  return {
    getUserStatus,
    userStatus: data?.userStatusByEmail,
    loading,
    error,
  };
};

